import map from 'lodash/map';
import uniq from 'lodash/uniq';

export const toArray = (object) => {
    return map(object, prop => prop);
}

export const uniqObj = (array) => {
    return map(
        uniq(
            map(array, obj => {
                return JSON.stringify(obj);
            })
        ), obj => {
            return JSON.parse(obj);
        }
    )
} 


// WEBPACK FOOTER //
// ./src/js/utils/lodashUtils.js